<template>
  <div class="container">
    <!--搜索-->
    <div class="list-wrapper">
      <div class="table-wrap">
        <!-- 顶部搜索栏 -->
        <div class="serachBox">
          <el-form :inline="true" size="mini" :model="searchForm" label-width="70px">
            <div class="serach-header">
              <div style="display: flex; align-items: center">
                <el-form-item label="上市时间:" size="mini" class="datePicker">
                  <el-date-picker
                    v-model="searchForm.date"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="~"
                    :clearable="false"
                    unlink-panels
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    style="width: 228px !important"
                  ></el-date-picker>
                </el-form-item>
              </div>
              <div class="search-btn-box">
                <el-button type="primary" size="mini" class="search-btn" @click="init">搜索</el-button>
                <el-button type="info" size="mini" class="buttonStyle" style="margin-left: 5px" @click="reset">重置</el-button>
              </div>
            </div>
          </el-form>
        </div>

        <!-- 主体内容区域 -->
        <div class="main-grid">
          <!-- 第一行 -->
          <div class="top-row row">
            <!-- 左侧：上市新品数据 -->
            <div
              class="col top-left block"
              v-loading="loading2"
              element-loading-text="加载中..."
              element-loading-background="rgba(255, 255, 255, 0.3)"
            >
              <div class="block-header">
                <div class="header-left">
                  <span class="title">上市新品数据</span>
                  <span class="title-sub">({{ dateStartText }}-{{ dateEndText }})</span>
                  <div class="bottom-box">
                    <el-button
                      v-for="tab in tabButtons"
                      :key="tab.key"
                      :class="['tab-btn', { active: activeTab === tab.key }]"
                      size="mini"
                      @click="setActiveTab(tab.key)"
                    >
                      {{ tab.label }}
                    </el-button>
                  </div>
                </div>
                <span class="link-text" @click="goProductList">查看明细数据</span>
              </div>
              <div>
                <el-image :src="titleImg"></el-image>
              </div>
              <div class="kpi-summary">
                <div class="kpi-item">
                  <span class="kpi-label">累计上新（个）</span>
                  <span class="kpi-value">{{ mock.topSummary.total }}</span>
                </div>
                <div class="kpi-item">
                  <span class="kpi-label">累计同比</span>
                  <span class="kpi-value highlight">{{ mock.topSummary.yoy }}</span>
                </div>
              </div>
              <div ref="topTrend" class="chart-container"></div>
            </div>

            <!-- 中间：上市清单数据 -->
            <div class="col top-middle block">
              <div class="block-header">
                <div class="header-left">
                  <span class="title">上市清单数据</span>
                  <span class="title-sub">({{ dateStartText }}-{{ dateEndText }})</span>
                </div>
              </div>
              <div>
                <el-image :src="titleImg"></el-image>
              </div>
              <div class="kpi-list">
                <div v-for="(item, index) in mock.kpiList" :key="item.ref" class="kpi-list-item module">
                  <div class="kpi-list-content">
                    <div class="kpi-list-label">{{ item.label }}</div>
                    <div class="kpi-list-right">同比</div>
                  </div>
                  <div class="kpi-list-content">
                    <div class="kpi-list-value">{{ item.value }}</div>
                    <div class="kpi-list-right">
                      <span>{{ item.sub }}</span>
                      <img :src="parseFloat(item.sub) >= 0 ? upImg : downImg" class="compare-icon" />
                    </div>
                  </div>
                  <div v-if="index < mock.kpiList.length - 1" class="kpi-list-divider"></div>
                </div>
              </div>
            </div>

            <!-- 右侧：新品销售数据 -->
            <div
              class="col top-right block"
              v-loading="loading3"
              element-loading-text="加载中..."
              element-loading-background="rgba(255, 255, 255, 0.3)"
            >
              <div class="block-header">
                <div class="header-left">
                  <span class="title">新品销售数据</span>
                  <!-- <span class="title-sub">({{ dateStartText }}-{{ dateEndText }})</span> -->
                </div>
                <div class="header-right datePicker">
                  <span class="header-label">付款时间:</span>
                  <el-date-picker
                    v-model="searchForm.payDate"
                    type="daterange"
                    size="mini"
                    value-format="yyyy-MM-dd"
                    range-separator="~"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    class="sale-date-picker"
                    style="width: 228px"
                    :clearable="false"
                    unlink-panels
                    @change="payDateChange"
                  ></el-date-picker>
                  <span class="link-text" style="margin-left: 10px" @click="goProductSalesData">查看明细数据</span>
                </div>
              </div>
              <div>
                <el-image :src="titleImg"></el-image>
              </div>
              <div class="sale-grid">
                <div v-for="item in mock.saleKpis" :key="item.ref" class="sale-box moduleBig">
                  <div class="sale-circle-wrapper">
                    <div :ref="item.ref" class="sale-chart"></div>
                    <div class="sale-circle-inner">
                      <div class="sale-label">{{ item.label }}</div>
                      <div class="sale-value">{{ item.value }}</div>
                    </div>
                  </div>
                  <div class="sale-info-box">
                    <div class="sale-info">
                      <div class="sale-ratio-label">{{ item.ratioLabel }}</div>
                      <div>
                        <span>{{ item.ratio }}</span>
                      </div>
                    </div>
                    <div class="sale-info-divider"></div>
                    <div class="sale-info">
                      <div><span>同比</span></div>
                      <div class="kpi-list-right">
                        <span style="margin-left: 20px">{{ item.compareValue }}</span>
                        <img :src="parseFloat(item.compareValue) >= 0 ? upImg : downImg" class="compare-icon" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 第二行 -->
          <div class="bottom-row row">
            <!-- 左侧：店铺上架数据 -->
            <div class="col bottom-left block">
              <div class="block-header">
                <div class="header-left">
                  <span class="title">店铺上架数据</span>
                  <span class="title-sub">({{ dateStartText }}-{{ dateEndText }})</span>
                </div>
              </div>
              <div>
                <el-image :src="titleImg"></el-image>
              </div>
              <div class="status-summary">
                <div class="status-kpi">
                  <div class="status-label">需上架总商品数 (个)</div>
                  <div class="status-value">{{ mock.meta.needTotalQty }}</div>
                </div>
                <div class="status-kpi">
                  <div class="status-label">平均完成上架周期 (天)</div>
                  <div class="status-value">{{ mock.meta.daysTaken }}</div>
                </div>
              </div>
              <div class="rings-grid">
                <div v-for="item in mock.rings" :key="item.ref" class="ring-box">
                  <div :ref="item.ref" class="ring-chart"></div>
                </div>
              </div>
            </div>

            <!-- 右侧：店铺上架数据趋势表现 -->
            <div class="col bottom-right block">
              <div class="block-header">
                <div class="header-left">
                  <span class="title">店铺上架数据趋势表现</span>
                  <span class="title-sub">({{ dateStartText }}-{{ dateEndText }})</span>
                </div>
                <div class="header-right">
                  <span class="link-text" @click="goStroeMangement">查看明细数据</span>
                </div>
              </div>
              <div>
                <el-image :src="titleImg"></el-image>
              </div>
              <div ref="storesBarLine" class="chart-container"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import titleImg from '@/assets/images/newProduct_img/headerTitle.png';
import upImg from '@/assets/images/newProduct_img/up.png';
import downImg from '@/assets/images/newProduct_img/down.png';
import topTrend from './topTrend.mixin';
import statusRings from './statusRings.mixin';
import storesBarLine from './storesBarLine.mixin';
import moment from 'moment';
export default {
  name: 'newProductStatistics',
  mixins: [topTrend, statusRings, storesBarLine],
  data() {
    return {
      searchForm: {
        date: [moment().subtract('month', 6).format('YYYY-MM-DD'), moment().subtract('days').format('YYYY-MM-DD')],
        payDate: [moment().subtract('month', 6).format('YYYY-MM-DD'), moment().subtract('days').format('YYYY-MM-DD')],
      },
      activeTab: 1,
      tabButtons: [
        { key: 1, label: '型号' },
        { key: 2, label: '产品' },
        { key: 3, label: '商品' },
        { key: 4, label: 'SPU' },
      ],
      titleImg: titleImg,
      upImg: upImg,
      downImg: downImg,
      dateStartText: '',
      dateEndText: '',
      loading: false,
      loading2: false,
      loading3: false,
      loadingNumber: 0,
      colorIndex: 0,
      currencyForm: {
        pageSize: 10000,
        pageNum: 1,
        reportCode: '',
        param: '',
        queryMatch: [],
        orderList: [],
        orderType: '',
        hasCount: '',
        groupAttr: '',
      },
      storesPoorList: [],
      overviewText: [],
      allCount: 0,
      timeText: {},
      mock: {
        topSummary: { total: 0, yoy: '0%' },
        topTrend: [],
        kpiList: [
          { value: 0, label: '累计上市清单(批次)', sub: '0%' },
          { value: 0, label: '清单平均完成周期(天)', sub: '0%' },
          { value: 0, label: '清单平均延期时间(天)', sub: '0%' },
        ],
        saleKpis: [
          { value: 0, label: '商品销量(款)', ratioLabel: '销量占比(全年)', ratio: '0%', compareValue: '0%' },
          { value: 0, label: '产品销量(款)', ratioLabel: '产品占比(全年)', ratio: '0%', compareValue: '0%' },
          { value: 0, label: '销售额(万)', ratioLabel: '销售额占比(全年)', ratio: '0%', compareValue: '0%' },
        ],
        rings: [
          { ref: 'ring1', name: '已上架', value: 0, percent: 0 },
          { ref: 'ring2', name: '待上架', value: 0, percent: 0 },
          { ref: 'ring3', name: '无需上架', value: 0, percent: 0 },
          { ref: 'ring4', name: '暂缓上架', value: 0, percent: 0 },
        ],
        meta: { needTotalQty: 0, daysTaken: 0 },
        stores: [],
      },
    };
  },
  computed: {
    dateStart() {
      return JSON.parse(JSON.stringify(this.searchForm.date[0]));
    },
    dateEnd() {
      return JSON.parse(JSON.stringify(this.searchForm.date[1]));
    },
    windowWidth() {
      return window.innerWidth;
    },
  },
  watch: {
    dateStart: {
      handler(val, old) {
        if (!val) return;
        let startMonth = parseInt(val.substring(5, 7));
        let startDay = parseInt(val.substring(8));
        this.dateStartText = startMonth + '.' + startDay;
      },
      immediate: true,
    },
    dateEnd: {
      handler(val, old) {
        if (!val) return;
        let endMonth = parseInt(val.substring(5, 7));
        let endDay = parseInt(val.substring(8));
        this.dateEndText = endMonth + '.' + endDay;
      },
      immediate: true,
    },
    loadingNumber(val, old) {
      if (val == 5) {
        setTimeout(_=>{
          this.loading.close();
        },500)
        this.loadingNumber = 0;
      }
    },
  },
  methods: {
    setActiveTab(key) {
      this.loading2 = true;
      this.activeTab = key;
      this.newProductOnSale(true);
      // 可以在这里添加切换tab后的逻辑
    },
    payDateChange(val) {
      this.loading3 = true;
      this.newProductSaleData(true);
    },
    async init() {
      this.loadingNumber = 0
      this.loading = this.$loading({
        lock: true,
        text: '加载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(255, 255, 255, 0.7)',
      });
      this.newProductOnSale();
      this.saleListData();
      this.newProductSaleData();
      this.storeData();
      this.storeItemData();
    },

    reset() {
      this.searchForm = {
        date: [moment().subtract('month', 6).format('YYYY-MM-DD'), moment().subtract('days').format('YYYY-MM-DD')],
        payDate: [moment().subtract('month', 6).format('YYYY-MM-DD'), moment().subtract('days').format('YYYY-MM-DD')],
      };
      this.activeTab = 1;
      this.init();
    },

    newProductOnSale(type) {
      !type && this.loadingNumber++;
      let data = {
        dts: this.searchForm.date[0],
        dte: this.searchForm.date[1],
        type: this.activeTab,
      };
      this.$q.dataBoard
        .newProductOnSale({ data })
        .then(res => {
          console.log(res);
          this.mock.topSummary.total = res.data.qty;
          this.mock.topSummary.yoy = res.data.yoy;
          this.mock.topTrend = res.data.onSaleVOList;
          this.$nextTick(() => {
            this.renderTopTrend(this.mock.topTrend);
          });
        })
        .finally(_ => {
          this.loading2 = false;
        });
    },

    saleListData() {
      this.loadingNumber++;
      const formData = new FormData();
      formData.append('dts', this.searchForm.date[0]);
      formData.append('dte', this.searchForm.date[1]);
      this.$q.dataBoard.saleListData({ data: formData }).then(res => {
        this.$set(this.mock.kpiList, 0, { value: res.data.batchQty || 0, label: '累计上市清单(批次)', sub: res.data.batchYoy || '0%' });
        this.$set(this.mock.kpiList, 1, { value: res.data.cycleDay || 0, label: '清单平均完成周期(天)', sub: res.data.cycleYoy || '0%' });
        this.$set(this.mock.kpiList, 2, { value: res.data.delayDay || 0, label: '清单平均延期时间(天)', sub: res.data.delayYoy || '0%' });
      });
    },

    newProductSaleData(type) {
      !type && this.loadingNumber++;
      let data = {
        dts: this.searchForm.date[0],
        dte: this.searchForm.date[1],
        payDts: this.searchForm.payDate[0],
        payDte: this.searchForm.payDate[1],
      };
      this.$q.dataBoard
        .newProductSaleData({ data })
        .then(res => {
          this.$set(this.mock.saleKpis, 0, {
            value: res.data.goodsSaleQty || 0,
            label: '商品销量(款)',
            ratioLabel: '销量占比(全年)',
            ratio: res.data.goodsSaleQtyProportion || '0%',
            compareValue: res.data.goodsSaleQtyYoy || '0%',
          });
          this.$set(this.mock.saleKpis, 1, {
            value: res.data.productSaleQty || 0,
            label: '产品销量(款)',
            ratioLabel: '产品占比(全年)',
            ratio: res.data.productSaleQtyProportion || '0%',
            compareValue: res.data.productSaleQtyYoy || '0%',
          });
          this.$set(this.mock.saleKpis, 2, {
            value: res.data.saleAmount || 0,
            label: '销售额(万)',
            ratioLabel: '销售额占比(全年)',
            ratio: res.data.saleAmountProportion || '0%',
            compareValue: res.data.saleAmountYoy || '0%',
          });
        })
        .finally(_ => {
          this.loading3 = false;
        });
    },

    storeData() {
      this.loadingNumber++;
      const formData = new FormData();
      formData.append('dts', this.searchForm.date[0]);
      formData.append('dte', this.searchForm.date[1]);
      this.$q.dataBoard.storeData({ data: formData }).then(res => {
        this.$set(this.mock.rings, 0, { ref: 'ring1', name: '已上架', value: res.data.upQty || 0, percent: res.data.upQtyProportion || '0%' });
        this.$set(this.mock.rings, 1, { ref: 'ring2', name: '待上架', value: res.data.waiteQty || 0, percent: res.data.waiteQtyProportion || '0%' });
        this.$set(this.mock.rings, 2, { ref: 'ring3', name: '无需上架', value: res.data.noNeedQty || 0, percent: res.data.noNeedQtyProportion || '0%' });
        this.$set(this.mock.rings, 3, { ref: 'ring4', name: '暂缓上架', value: res.data.cannotQty || 0, percent: res.data.cannotQtyProportion || '0%' });
        this.mock.meta.needTotalQty = res.data.needTotalQty || 0;
        this.mock.meta.daysTaken = res.data.daysTaken || 0;
        this.$nextTick(() => {
          this.renderStatusRings(this.mock.rings);
        });
      });
    },
    storeItemData() {
      this.loadingNumber++;
      const formData = new FormData();
      formData.append('dts', this.searchForm.date[0]);
      formData.append('dte', this.searchForm.date[1]);
      this.$q.dataBoard.storeItemData({ data: formData }).then(res => {
        this.mock.stores = res.data;
        this.$nextTick(() => {
          this.renderStoresBarLine(this.mock.stores);
        });
      });
    },

    handlerDatas(arr) {
      console.log(arr);
      let obj = {};
      arr.forEach((item, index) => {
        let { platName } = item;
        if (!obj[platName]) {
          obj[platName] = {
            platName,
            children: [],
          };
        }
        obj[platName].children.push(item);
      });
      let data = Object.values(obj); // 最终输出
      return data;
    },

    handleResize() {
      // 重新渲染所有图表以适应窗口大小变化
      this.$nextTick(() => {
        // 重新渲染趋势图
        if (this.$refs.topTrend) {
          const chart = this.$echarts.getInstanceByDom(this.$refs.topTrend);
          if (chart) chart.resize();
        }
        // 重新渲染店铺柱状图
        if (this.$refs.storesBarLine) {
          const chart = this.$echarts.getInstanceByDom(this.$refs.storesBarLine);
          if (chart) chart.resize();
        }
        // 重新渲染所有销售圆环图和进度条
        [...this.mock.saleKpis, ...this.mock.rings].forEach(item => {
          const refEl = this.$refs[item.ref];
          if (refEl) {
            const el = Array.isArray(refEl) ? refEl[0] : refEl;
            const chart = this.$echarts.getInstanceByDom(el);
            if (chart) chart.resize();
          }
        });
      });
    },
    goProductList() {
      //分别对应 型号、产品、商品、SPU 点击查看明细跳转路径
      let path = ['/product/list', '/product/list', '/goods/list', '/newProduct/newproduct-process'];
      this.$router.push({
        path: path[this.activeTab - 1],
        query: {
            marketOnBegin: this.searchForm.date[0],
            marketOnEnd: this.searchForm.date[1],
          },
      });
    },
    goProductSalesData() {
      this.$router.push({
        path: '/productSalesData',
        query: {
          marketOnBegin: this.searchForm.date[0],
          marketOnEnd: this.searchForm.date[1],
          planTimeStart: this.searchForm.payDate[0],
          planTimeEnd: this.searchForm.payDate[1],
        },
      });
    },

    goStroeMangement() {
      this.$router.push({
        path: '/newProduct/newproduct-launch-count',
        query: {
          activeName: 'StoreData'
        },
      });
    },
  },

  mounted() {
    // 初始化日期文本（静态页无接口也能展示区间）
    if (Array.isArray(this.searchForm.date) && this.searchForm.date.length === 2) {
      const [s, e] = this.searchForm.date;
      this.dateStartText = parseInt(String(s).slice(5, 7)) + '.' + parseInt(String(s).slice(8));
      this.dateEndText = parseInt(String(e).slice(5, 7)) + '.' + parseInt(String(e).slice(8));
    }
    this.init();

    // 监听窗口大小变化
    // window.addEventListener('resize', this.handleResize);
  },
  // beforeDestroy() {
  //   window.removeEventListener('resize', this.handleResize);
  // },
};
</script>

<style lang="stylus" scoped>
.container {
  margin: 5px;
  width: auto;
  height: calc(100vh - 76px);
  box-sizing: border-box;
  background: #0B352B;
  border-radius: 5px;
  position: relative;
  padding: 0;
  border: 0;
  z-index: 0;
  overflow-y: auto;

  &::before {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0px;
    top: 0px;
    content: '';
    background: url('../../../assets/images/newProduct_img/bg.png') no-repeat center 0px;
    background-size: cover;
    background-repeat: replace;
    z-index: -1;
  }

  /* 自定义滚动条样式 */
  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: rgba(5, 72, 56, 0.3);
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(11, 183, 142, 0.5);
    border-radius: 4px;

    &:hover {
      background: rgba(11, 183, 142, 0.7);
    }
  }
}

// 搜索按钮样式
>>> .el-button--primary.search-btn {
  background: #0BB78E !important;
  border-color: #0BB78E !important;
  color: #fff !important;

  &:hover {
    opacity: 0.9;
  }
}

>>> .el-button--info.search-btn {
  background: rgba(5, 72, 56, 0.8) !important;
  border: 1px solid rgba(123, 255, 224, 0.5) !important;
  color: #7BFFE0 !important;

  &:hover {
    background: rgba(5, 72, 56, 1) !important;
  }
}

>>> .el-main {
  padding: 10px;
  z-index: 2;
  background: transparent;
}

>>> .el-form-item {
  margin-bottom: 0 !important;
}

>>> .el-divider {
  margin: 10px 0;
}

.list-wrapper {
  padding: 5px;
  height: calc(100% - 10px);
}

.table-wrap {
  height: 100%;
  display: block;
}

/* 主体网格布局 */
.main-grid {
  min-height: calc(100% - 52px);
  display: flex;
  flex-direction: column;
}

.row {
  display: flex;
  gap: 5px;
}

.col {
  flex: 1;
}

.block {
  background: rgba(5, 72, 56, 0.6);
  padding: 12px;
  border-radius: 4px;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.top-row {
  min-height: 400px;
  margin-bottom: 5px;
}

.bottom-row {
  min-height: 375px;
}

.top-left {
  flex: 1.2;
}

.top-middle {
  flex: 0.6;
}

.top-right {
  flex: 1.2;
}

.bottom-left {
  flex: 0.8;
}

.bottom-right {
  flex: 1.2;
}

/* 区块头部 */
.block-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 26px;
  padding-bottom: 8px;
}

.header-left {
  display: flex;
  align-items: baseline;
  gap: 8px;
}

.bottom-box{
  margin-left: 10px;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 5px;
}

.header-label {
  font-family: PingFangSC;
  color: #FFFFFF;
  font-size: 12px;
  margin-right: 5px;
}

.title {
  font-family: SourceHanSansCN;
  color: #fff;
  font-size: 15px;
  font-weight: bold;
}

.title-sub {
  font-family: PingFangSC;
  color: #7BFFE0;
  font-size: 13px;
}

/* Tab按钮 */
.tab-btn {
  background-color: transparent !important;
  color: #7BFFE0 !important;
  border: 1px solid rgba(46, 246, 217, 0.3) !important;
  padding: 7px 13px !important;
  font-family: PingFangSC !important;
  font-size: 12px !important;
  border-radius: 2px !important;

  &:hover {
    background: #0BB78E !important;
    border-color: #0BB78E !important;
    color: #fff !important;
  }

  &.active {
    background: #0BB78E !important;
    border-color: #0BB78E !important;
    color: #fff !important;
  }
}

/* KPI汇总区 */
.kpi-summary {
  display: flex;
  gap: 20px;
  margin-bottom: 8px;
  padding: 8px 0;
}

.kpi-item {
  display: flex;
  align-items: center;
  gap: 20px;
}

.kpi-label {
  font-family: PingFangSC;
  color: #fff;
  font-size: 14px;
}

.kpi-value {
  font-family: YinHei;
  color: #FADB65;
  font-size: 22px;
  font-weight: bold;
}

.kpi-value.highlight {
  color: #2EF9C6;
}

.trend-icon {
  width: 16px;
  height: 16px;
}

/* 图表容器 */
.chart-container {
  flex: 1;
  width: 100%;
  min-height: 200px;
}

/* 区块底部 */
.block-footer {
  margin-top: 8px;
  text-align: right;
}

.link-text {
  color: #2EF9C6;
  font-size: 12px;
  cursor: pointer;
  font-family: PingFangSC;

  &:hover {
    text-decoration: underline;
  }
}

/* KPI网格（清单数据、销售数据） */
.kpi-grid {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  gap: 10px;
}

.kpi-box {
  flex: 1;
  width: 100%;
  min-height: 0;
}

.module {
  color: rgba(255, 255, 255, 0.85);
  font-family: PingFangSC;
  background: url('../../../assets/images/newProduct_img/module.png') no-repeat center 0px;
  background-size: 100% 100%;
}

.moduleBig {
  color: rgba(255, 255, 255, 0.85);
  font-family: PingFangSC;
  background: url('../../../assets/images/newProduct_img/moduleBig.png') no-repeat center center;
  background-size: 100% 100%;
  padding: 15px;
}

.kpi-chart {
  width: 100%;
  height: 100%;
  min-height: 80px;
}

/* KPI列表样式（清单数据） */
.kpi-list {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  padding: 10px 0;
}

.kpi-list-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 10px;
}

.kpi-list-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  margin: 5px 0;
}

.kpi-list-label {
  flex: 1;
  font-family: PingFangSC;
  color: rgba(255, 255, 255, 0.85);
  font-size: 13px;
  text-align: left;
}

.kpi-list-value {
  font-family: YinHei;
  color: #FADB65;
  font-size: 22px;
  font-weight: bold;
  margin: 0 20px;
}
.kpi-list-right {
  flex: 0.4
  font-family: PingFangSC;
  color: rgba(255, 255, 255, 0.85);
  font-size: 13px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.kpi-list-compare {
  display: flex;
  align-items: center;
  gap: 5px;
  font-family: PingFangSC;
  color: rgba(255, 255, 255, 0.85);
  font-size: 14px;
}

  .compare-icon {
    width: 14px;
    height: 14px;
    position: relative;
    top: -1px;
  }

/* 新品销售数据样式 */
.sale-grid {
  flex: 1;
  display: flex;
  gap: 15px;
  align-items: stretch;
  padding: 10px 0;
}

.sale-box {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
}

.sale-circle-wrapper {
  position: relative;
  width: 100%;
  height: 180px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
  background: rgba(2,53,44,0.5);
  border: 1px solid rgba(28,236,237,0.37);
  border-radius: 50%;
}

.sale-chart {
  width: 90%;
  height: 90%;
  position: absolute;
  top: calc(5% - 1px);
  left: calc(5% - 1px);
  border: 2px solid #44D7B6;
  border-radius: 50%;
  transform: none;
}

.sale-circle-inner {
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.sale-value {
  font-family: zihun54hao-xianhei;
  font-size: 28px;
  font-weight: bold;
  line-height: 1.2;
  margin-bottom: 5px;
}

.sale-box:nth-child(1) .sale-value {
  color: #FF9800; /* 橙黄色 */
}

.sale-box:nth-child(2) .sale-value {
  color: #23BE72; /* 绿色 */
}

.sale-box:nth-child(3) .sale-value {
  color: #00D1C8; /* 青色 */
}

.sale-label {
  font-family: PingFangSC;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.85);
  white-space: nowrap;
  margin-bottom: 10px;
}

.sale-info-box {
  height: 30%;
  width: 100%;
  font-size: 13px;
}

.sale-info-divider{
  margin: 5px 0
  height: 0.5px;
  background-color: rgba(255,255,255,0.2);
}

.sale-info {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
}

.sale-ratio-label {
  font-family: PingFangSC;
  color: rgba(255, 255, 255, 0.85);
  margin-bottom: 5px;
}

.sale-compare {
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: PingFangSC;
  color: rgba(255, 255, 255, 0.85);
  font-size: 12px;
}

.sale-date-picker {
  >>> .el-input__inner {
    height: 28px;
    line-height: 28px;
  }
}

/* 状态汇总 */
.status-summary {
  display: flex;
  gap: 15px;
  margin-bottom: 12px;
}

.status-kpi {
  flex: 1;
  padding: 20px;
  text-align: center;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: rgba(255, 255, 255, 0.85);
  font-family: PingFangSC;
  background: url('../../../assets/images/newProduct_img/module.png') no-repeat center 0px;
  background-size: 100% 100%;
}

.status-label {
  font-family: PingFangSC;
  color: #fff;
  font-size: 14px;
  margin-bottom: 5px;
}

.status-value {
  font-family: YinHei;
  color: #FADB65;
  font-size: 20px;
  font-weight: bold;
}

/* 进度图网格 */
.rings-grid {
  flex: 1;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
  align-items: center;
  padding-top: 8px;
}

.ring-box {
  width: 100%;
  height: 100%;
  min-height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.ring-chart {
  width: 100%;
  height: 100%;
  min-height: 120px;
}


.serachBox {
  background: rgba(5, 72, 56, 0.6);
  height: 42px;
  line-height: 42px;
  margin-bottom: 5px;
}

.serach-header {
  padding-left: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.search-btn-box {
  margin: -3px 10px 0 0;
  display: flex;
  align-items: center;
  gap: 5px;
}

.buttonStyle {
  background-color: transparent;
  color: #7BFFE0;
  border: 1px solid;
  border-image: linear-gradient(270deg, rgba(11, 183, 142, 1), rgba(123, 255, 224, 1), rgba(11, 183, 142, 1)) 1 1;
  padding: 5px 15px;
}

>>> .serachBox .el-button {
  padding: 7px 13px
}

>>> .el-input__inner {
  background-color: transparent;
  border: 1px solid;
  border-image: linear-gradient(270deg, rgba(11, 183, 142, 1), rgba(123, 255, 224, 1), rgba(11, 183, 142, 1)) 1 1;
  border-radius: 2px;
  font-size: 12px;
  color: #7BFFE0;
  font-family: PingFangSC;

  &::placeholder {
    color: rgba(123, 255, 224, 0.6);
    font-size: 12px;
  }
}

>>> .el-icon-date:before {
  content: '\E78E';
  color: #7BFFE0;
}

>>> .form-date-picker .el-date-editor {
  width: 135px !important;
}

>>> .el-form--inline .el-form-item__label {
  color: #FFFFFF;
  font-family: PingFangSC;
  font-size: 12px;
}

>>> .datePicker .el-date-editor .el-range-input {
  background: transparent;
  color: #7BFFE0;
  font-size: 12px;
  font-family: PingFangSC;

  &::placeholder {
    color: rgba(123, 255, 224, 0.6);
    font-size: 12px;
  }
}

>>> .serachBox .el-form-item__content {
  line-height: 42px;
  font-size: 12px;
}

>>> .datePicker .el-range-editor.el-input__inner {
  height: 29px;
  padding: 0 10px;
}

>>> .serachBox .el-form-item--mini .el-form-item__label {
  line-height: 42px !important;
}

>>> .el-date-editor .el-range__icon {
  height: 28px;
  line-height: 28px !important;
}

>>> .el-date-editor .el-range__close-icon {
  height: 28px;
  line-height: 28px !important;
}

>>> .el-select .el-input .el-select__caret {
  height: 28px;
  line-height: 28px;
}

>>> .datePicker .el-range-editor--mini .el-range-separator {
  height: 42px;
  line-height: 42px;
  color: rgba(123, 255, 224, 0.6);
  font-size: 12px;
  font-family: PingFangSC;
}
</style>

<style scoped>
/* 响应式媒体查询 */
@media screen and (max-width: 1366px) {
  .title {
    font-size: 13px;
  }

  .title-sub {
    font-size: 11px;
  }

  .kpi-value {
    font-size: 18px;
  }

  .status-value {
    font-size: 18px;
  }

  .kpi-label,
  .status-label {
    font-size: 11px;
  }

  .tab-btn {
    padding: 5px 10px !important;
    font-size: 11px !important;
  }

  .block {
    padding: 8px;
  }

  .ring-chart {
    min-height: 100px;
  }

  .chart-container {
    min-height: 180px;
  }

  .kpi-summary {
    gap: 15px;
    padding: 5px 0;
  }

  .kpi-list-value {
    font-size: 18px;
  }

  .sale-circle-wrapper {
    height: 140px;
  }

  .sale-value {
    font-size: 22px;
  }

  .sale-label {
    font-size: 12px;
  }

  .status-summary {
    gap: 10px;
    margin-bottom: 8px;
  }

  .status-kpi {
    padding: 12px;
  }

  .top-row {
    min-height: 300px;
  }

  .bottom-row {
    min-height: 300px;
  }

  .kpi-list {
    padding: 10px 0;
  }

  .kpi-list-content {
    padding: 0 15px;
  }
  .kpi-list-label {
    font-size: 12px;
  }
  .kpi-list-right {
    font-size: 12px;
  }

  .sale-grid {
    gap: 10px;
    padding: 5px 0;
  }

  .sale-info-box {
    height: auto;
    font-size: 12px;
  }

  .sale-info {
    margin-top: 5px;
  }

  .top-middle {
    flex: 0.5;
  }

  .top-right {
    flex: 1.3;
  }

  .rings-grid {
    gap: 8px;
  }

  .block-header {
    padding-bottom: 5px;
  }

  .header-label {
    font-size: 11px;
  }

  .link-text {
    font-size: 11px;
  }

  .serachBox .el-button {
    padding: 6px 10px;
  }
}

@media screen and (min-width: 1600px) and (max-width: 1768px) {
  .kpi-value {
    font-size: 20px;
  }

  .status-value {
    font-size: 22px;
  }

  .ring-chart {
    min-height: 150px;
  }
}
</style>
